module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/frat-partnerships-a7f244678ce68f6c8ec9dd2065065d3f.webp";